<template>
  <div id="ProgressDots">
    <div class="col-xs-offset-2 col-xs-8">
      <div class="csp-progress-group">
       <div class="csp-progress-dot" v-for="n in totalSteps" v-bind:class="{ 'primary-color': n == currentStep }"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProgressDots',
    props: {
      totalSteps: {
        type: Number,
        required: true
      },
      currentStep: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style scoped>

  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// ProgressDots.vue?8d3519a0